<template>
	<div style="height: 84vh;">
		<div class="tenant_search">
			<div class="tenant_search_1">
				<i class="ione"></i>
				<el-input placeholder="请输入进出租客" prefix-icon="el-icon-search" v-model="data.name" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="请输入手机号" prefix-icon="el-icon-search" v-model="data.phone" @keyup.enter.native="search()"
					@change="handleStatusChange"></el-input>
			</div>
			<div class="tenant_search_1" v-show="launched">
				<i></i>
				<el-input placeholder="请输入房间号" prefix-icon="el-icon-search" v-model="data.room_num"
					@keyup.enter.native="search()" @change="handleStatusChange"></el-input>
			</div>

			<div style="display: flex;justify-content: space-between;width: 100%;align-items: center;"
				:style="{ marginLeft: minw ? '1rem' : '0' ,marginRight: minw ? '1rem' : '0'}">
				<div>
					<button class="search_button" @click="search()">搜索</button>
					<button class="search_button" @click="search('重置')">重置</button>
				</div>
				<div v-show="minw" style="display: flex;align-items: center;">
					<p style="color: #909399;">{{launched?'收起':'展开'}}</p>
					<i size="mini" :class="launched?'el-icon-arrow-up':'el-icon-arrow-down'" @click="launched=!launched"></i>
				</div>

			</div>
		</div>
		<ListingButton :lists="lists"></ListingButton>
		<MyTable :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			style="margin: 1rem;"></MyTable>

		<Mycell :tableData="tableData" :table_label="table_label" :name="name" :total="total" :page="data.page"
			@BatchDeleteValue="DeleteValue" @Edit="Edit" @Delete="Delete" @Currentchange="contractlistcontractlist"
			style="padding-bottom: 4rem;"></Mycell>
	</div>
</template>

<script>
	import ListingButton from "@/components/Listing_Button/index.vue"
	import MyTable from "@/components/MyTable/index.vue"
	import Mycell from "@/components/My_cell/index.vue"
	import {
		comeOutLog_list,
		comeOutLog_delete
	} from "@/api/api.js"
	export default {
		data() {
			return {
				name: 'entry',
				lists: [{
					name: '删除',
					type: 'danger',
					icon: 'el-icon-delete'
				}, ],
				tableData: [{
					contract_number: 1,
					name: 1
				}, {
					contract_number: 1,
					name: 1
				}],
				table_label: [{
					label: 'ID',
					value: 'id'
				}, {
					label: '房间号',
					value: 'room_num'
				}, {
					label: '姓名',
					value: 'name'
				}, {
					label: '手机号',
					value: 'phone'
				}, {
					label: '大门',
					value: 'door'
				}, {
					label: '时间',
					value: 'create_time'
				}, {
					label: '开门类型',
					value: 'type'
				}],
				total: null,
				multipleSelection: [],
				EditValue: '',
				centerDialogVisible: false,
				DialogTitle: '',
				data: {
					page: 1,
					limit: 15,
					room_num: '',
					phone: '',
					name: ''
				},
				minw: JSON.parse(sessionStorage.getItem('minw')),
				launched: !JSON.parse(sessionStorage.getItem('minw'))
			}
		},
		methods: {
			search(resetting) {
				if (resetting != undefined) {
					this.data.room_num = ''
					this.data.name = ''
					this.data.phone = ''
					this.contractlistcontractlist(this.data.page)
				} else {
					sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 1);

					this.contractlistcontractlist('搜索')
				}
			},
			handleStatusChange() {
				sessionStorage.setItem(this.$router.currentRoute.path + 'search_status', 0);
			},
			contractlistcontractlist(value) {


				if (value == '搜索') {
					this.data.page = 1
				} else if (sessionStorage.getItem(this.$router.currentRoute.path + 'search_status') == 1) {
					this.data.page = value ? value : this.data.page
				} else {
					this.data = {
						page: value ? value : this.data.page,
						limit: 15
					}
				}
				comeOutLog_list(this.data).then(res => {
					console.log('res', res);
					if (res.status == 200) {
						this.tableData = res.data.list
						this.total = res.data.count
						if (res.__requestPayload) {
							this.data = res.__requestPayload
						}
					}
				})
			},
			//点击编辑
			Edit(value) {
				console.log('Edit', value);
				this.EditValue = value
				this.centerDialogVisible = true
				this.DialogTitle = '合同编辑'
			},
			// 批量删除的数组
			DeleteValue(value) {
				this.multipleSelection = value
			},
			// 批量删除的方法
			BatchDelete() {
				comeOutLog_delete({
					ids: this.multipleSelection
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
				console.log(111);
			},
			// 点击删除
			Delete(value) {
				console.log("Delete", value.id);
				comeOutLog_delete({
					ids: [`${value.id}`]
				}).then(res => {
					this.Messages(res)
					this.contractlistcontractlist()
				})
			},
			Messages(i) {
				if (i.status == 200) {
					this.$message({
						message: i.msg,
						type: 'success'
					});
				} else {
					this.$message({
						message: i.msg,
						type: 'error'
					});
				}
			}
		},
		components: {
			MyTable,
			ListingButton,
			Mycell
		},
		created() {

			this.contractlistcontractlist()
		},
	}
</script>

<style scoped>
	.tenant_search {
		display: flex;
		align-items: center;
		background-color: var(--cont_backgound);
		margin: 1.25rem;
		padding: 10px;
		border-radius: 8px;
	}

	::v-deep .el-input__inner:focus {
		border: 1px solid #3C46FF;
	}

	.tenant_search_1 {
		display: flex;
		align-items: center;

	}

	.tenant_search_1 span {
		width: 2.6rem;

	}

	.tenant_search .tenant_search_1:first-child i {
		margin-left: 0rem;
	}

	.tenant_search_1 i {
		height: 1.25rem;
		width: 0.375rem;
		background-color: #3C46FF;
		border-radius: 0.625rem;
		margin: 0 0.625rem;
		margin-left: 1rem;
	}

	.tenant_search :nth-child(2) span {
		width: 4.8rem;
	}


	.tenant_search_1 .el-input {
		width: 9rem;
	}

	.search_button {
		font-size: 0.85rem;
		height: 2rem;
		width: 5rem;
		margin: 0 0.625rem;
		background-color: #409eff;
		border: #409eff;
		color: #fff;
		border-radius: 6px;
	}

	.search_button:hover {
		opacity: 0.8;
	}
</style>